/* "Weitere Designs" scroller — arrow buttons scroll the row; arrows disable
   at the ends. Native swipe/trackpad scrolling works without JS. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.relatedInit) return;
    root.dataset.relatedInit = '1';

    var scroller = root.querySelector('[data-related-scroller]');
    var prev = root.querySelector('[data-related-prev]');
    var next = root.querySelector('[data-related-next]');
    if (!scroller) return;

    function step() {
      var item = scroller.querySelector('.valismo-related__item');
      var w = item ? item.getBoundingClientRect().width + 20 : 280;
      return Math.max(w, scroller.clientWidth * 0.8);
    }

    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth - 2;
      if (prev) prev.disabled = scroller.scrollLeft <= 2;
      if (next) next.disabled = scroller.scrollLeft >= max;
    }

    if (prev) prev.addEventListener('click', function () {
      scroller.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      scroller.scrollBy({ left: step(), behavior: 'smooth' });
    });

    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-related]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-related]');
    if (root) init(root);
  });
})();
